import { MUTATION_TYPE, ACTION_TYPE, GETTER_TYPE } from './types'
import workspaceApi from '@/api/workspace'

export default {
  state: {
    files: [],
    workspace: []
  },

  mutations: {
    [MUTATION_TYPE.setFiles]: (state, files) => {
      state.files = files
    },
    [MUTATION_TYPE.setWorkspace]: (state, workspace) => {
      state.workspace = workspace
    }
  },

  actions: {
    [ACTION_TYPE.fetchFiles]: ({ commit }, payload) => new Promise((resolve, reject) => {
      workspaceApi.getFiles(payload.date, payload.type, payload.search)
        .then((response) => {
          commit('setFiles', response.data.files)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    }),
    [ACTION_TYPE.fetchWorkspace]: ({ commit }, type) => new Promise((resolve, reject) => {
      workspaceApi.getWorkspace(type)
        .then((response) => {
          commit('setWorkspace', response.data.workspace)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    }),
    [ACTION_TYPE.uploadFiles]: (_, files) => new Promise((resolve, reject) => {
      workspaceApi.uploadFiles(files)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getters: {
    [GETTER_TYPE.getFiles]: (state) => state.files,
    [GETTER_TYPE.getWorkspace]: (state) => state.workspace
  }
}
